import { URL } from "../utils/constants.ts";

const localURL = "https://localhost:5001/api";
export async function getFilaments() {
  let url = URL + "/Filament/filamente";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const filaments = await response.json();

  return filaments.map((filament) => {
    return {
      colorName: filament.colorName,
      colorCode: filament.colorCode,
      filamentConfig: {
        material: filament.material,
        supplierName: filament.supplierName,
        spoolWeight: filament.spoolWeight,
        weight: filament.weight,
        temperature: filament.temperature,
        filamentID: filament.filamentID,
      },
    };
  });
}

export async function updateFilamentWeight(filamentID, weight) {
  const url = URL + `/Filament/${filamentID}?weight=${weight}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the filament weight."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }

  // Check if the response has content
  if (response.status !== 204 && response.status !== 200) {
    const error = new Error("Unexpected response status.");
    error.code = response.status;
    error.info = await response.text(); // Get raw response text
    throw error;
  }

  // If the response is successful and contains a body, parse it
  try {
    const updatedFilament = await response.json(); // Only call .json() if there is a response body
    return updatedFilament;
  } catch (e) {
    // If there's no JSON body, return a default object or handle as needed
    return null;
  }
}

export async function getSuppliers() {
  let url = URL + "/Filament/suppliers";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the filament types."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}

export async function getColors() {
  let url = URL + "/Filament/colors";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error(
      "An error occurred while fetching the filament types."
    );
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const data = await response.json();

  return data;
}

export async function addNewMaterialType(typeName) {
  const url = URL + "/Filament/material";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify({ typeName }),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating material type.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function addNewColor(color) {
  const url = URL + "/Filament/color";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify(color),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating color.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function addNewFilament(filament) {
  const url = URL + "/Filament";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify(filament),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating filament.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function getPrinters() {
  let url = URL + "/Printer/imprimante";

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const printers = await response.json();
  return printers;
}

export async function getPrinterDetails(id) {
  let url = URL + "/Printer/imprimante/" + id;

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const printers = await response.json();
  return printers;
}

export async function getPrinterFilaments(id) {
  let url = URL + "/PrinterFilament/ImprimanteFilament?id=" + id;

  const response = await fetch(url);

  if (!response.ok) {
    const error = new Error("An error occurred while fetching the categories.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  const printers = await response.json();
  return printers.map((item) => {
    return {
      colorName: item.filament.colorName,
      colorCode: item.filament.colorCode,
      filamentConfig: {
        material: item.filament.material,
        supplierName: item.filament.supplierName,
        spoolWeight: item.filament.spoolWeight,
        weight: item.filament.weight,
        temperature: item.filament.temperature,
        filamentID: item.filament.filamentID,
      },
    };
  });
}
export async function addNewPrinter(printer) {
  const url = URL + "/Printer/imprimanta";

  const formData = new FormData();
  formData.append("Name", printer.Name);
  formData.append("BedHeight", printer.BedHeight);
  formData.append("BedWidth", printer.BedWidth);
  formData.append("BedDepth", printer.BedDepth);
  formData.append("ColorSlots", printer.ColorSlots);
  formData.append("MaxNozzleTemp", printer.MaxNozzleTemp);
  formData.append("MaxPrintingSpeed", printer.MaxPrintingSpeed);
  formData.append("PrinterImage", printer.PrinterImage); // asigură-te că e un fișier valid

  const response = await fetch(url, {
    method: "POST",
    body: formData,
    // NU seta Content-Type manual aici!
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating printer.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function updatePrinterStatus(printerID, status) {
  const url = URL + `/Printer/${printerID}?statusNou=${status}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the filament weight."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }

  // Check if the response has content
  if (response.status !== 204 && response.status !== 200) {
    const error = new Error("Unexpected response status.");
    error.code = response.status;
    error.info = await response.text(); // Get raw response text
    throw error;
  }

  // If the response is successful and contains a body, parse it
  try {
    const updatedFilament = await response.json(); // Only call .json() if there is a response body
    return updatedFilament;
  } catch (e) {
    // If there's no JSON body, return a default object or handle as needed
    return null;
  }
}

export async function updatePrinterSettings(
  printerID,
  name,
  colorSlots,
  maxNozzleTemp
) {
  const url =
    URL +
    `/Printer/updateSettings/${printerID}?name=${name}&colorSlots=${colorSlots}&maxNozzleTemp=${maxNozzleTemp}`;

  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new Error(
      "An error occurred while updating the filament weight."
    );
    error.code = response.status;
    try {
      error.info = await response.json(); // Try to get the JSON error response
    } catch (e) {
      error.info = await response.text(); // Fallback to text if JSON is not available
    }
    throw error;
  }

  // Check if the response has content
  if (response.status !== 204 && response.status !== 200) {
    const error = new Error("Unexpected response status.");
    error.code = response.status;
    error.info = await response.text(); // Get raw response text
    throw error;
  }

  // If the response is successful and contains a body, parse it
  try {
    const updatedFilament = await response.json(); // Only call .json() if there is a response body
    return updatedFilament;
  } catch (e) {
    // If there's no JSON body, return a default object or handle as needed
    return null;
  }
}

export async function deletePrinter(printerID) {
  const url = URL + `/Printer/${printerID}`;

  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new Error("An error occurred while deleting the printer.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  // Check if the response has content
  if (response.status !== 204 && response.status !== 200) {
    const error = new Error("Unexpected response status.");
    error.code = response.status;
    error.info = await response.text();
    throw error;
  }

  // If DELETE was successful but no body, just return null
  return null;
}

export async function addNewCompatibility(printerId, filamentID) {
  const url =
    URL +
    `/PrinterFilament/ImprimanteFilament?FilamentID=${filamentID}&PrinterID=${printerId}`;

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating printer.");
    error.code = response.status;

    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function addNewSupplier(supplier) {
  const url = URL + "/Filament/supplier";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify(supplier),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating filament.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function addNewType(type) {
  const url = URL + "/Filament/material";

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "*/*",
    },
    body: JSON.stringify(type),
  });

  if (!response.ok) {
    const error = new Error("An error occurred while creating filament.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
}

export async function deleteCompatibility(printerID, filamentID) {
  const url = URL + `/PrinterFilament/${printerID}/${filamentID}`;

  const response = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new Error("An error occurred while deleting the printer.");
    error.code = response.status;
    try {
      error.info = await response.json();
    } catch (e) {
      error.info = await response.text();
    }
    throw error;
  }

  // Check if the response has content
  if (response.status !== 204 && response.status !== 200) {
    const error = new Error("Unexpected response status.");
    error.code = response.status;
    error.info = await response.text();
    throw error;
  }

  // If DELETE was successful but no body, just return null
  return null;
}
